"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _startCase = _interopRequireDefault(require("lodash/startCase"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var _snackbar = _interopRequireDefault(require("britive-design-system/core/components/snackbar"));

var _select = _interopRequireDefault(require("britive-design-system/core/components/select"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _textfield = _interopRequireDefault(require("britive-design-system/core/components/textfield"));

var _textarea = _interopRequireDefault(require("britive-design-system/core/components/textarea"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _table = _interopRequireDefault(require("britive-design-system/core/components/table"));

var _tooltip = _interopRequireDefault(require("britive-design-system/core/components/tooltip"));

var _deleteIcon = _interopRequireDefault(require("../../../../../assets/delete-icon.svg"));

var _submitTableRow = _interopRequireDefault(require("../../../../../assets/submit-table-row.svg"));

var _disabledSubmitTableRow = _interopRequireDefault(require("../../../../../assets/disabled-submit-table-row.svg"));

var _reactRedux = require("react-redux");

var _action = require("../../../../../components/notification/action");

var _utils = require("./utils");

var _ChannelNamesIdsList = _interopRequireDefault(require("./ChannelNamesIdsList"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.policy-approval-tab-main-container {\n  flex-grow: 1;\n  padding-top: 3rem;\n  padding-left: 3.5rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .policy-approval-tab-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .policy-approval-tab-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .policy-approval-tab-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .policy-approval-tab-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .policy-approval-tab-main-container .sm-form-name-loader-wrapper {\n    display: flex;\n    align-items: center; }\n    .policy-approval-tab-main-container .sm-form-name-loader-wrapper .sm-form-name-check-loader {\n      margin-top: 1.25rem;\n      margin-left: 0.625rem; }\n  .policy-approval-tab-main-container .sm-add-policy-field-wrapper {\n    margin-bottom: 2rem; }\n  .policy-approval-tab-main-container .sm-add-policy-field-value-wrapper {\n    margin-top: 0.5rem; }\n  .policy-approval-tab-main-container .sm-value-wrapper {\n    margin-top: 0.625rem; }\n  .policy-approval-tab-main-container .sm-table-container {\n    margin-top: 0.5rem;\n    max-height: 20rem;\n    overflow-y: scroll; }\n  .policy-approval-tab-main-container .action-icon {\n    cursor: pointer; }\n    .policy-approval-tab-main-container .action-icon-edit {\n      height: 1.5rem; }\n  .policy-approval-tab-main-container .action-icons-container {\n    display: flex;\n    justify-content: flex-start;\n    gap: 0.5rem; }\n  .policy-approval-tab-main-container .info-icon {\n    display: flex;\n    align-items: center;\n    gap: 0.3125rem; }\n    .policy-approval-tab-main-container .info-icon img {\n      height: 1.125rem; }\n";
  var fileName = "compone_AddApprovalTab";
  var element = document.querySelector("style[data-sass-component='compone_AddApprovalTab']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  },
  fieldContainer: {
    marginBottom: '8px'
  },
  channelsContainer: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
    alignItems: 'baseline'
  }
};

var NotificationMediumSelector = function NotificationMediumSelector(_ref) {
  var _notificationMedium$c;

  var onAdd = _ref.onAdd,
      onCancel = _ref.onCancel,
      error = _ref.error,
      selectedNotificationMediums = _ref.selectedNotificationMediums,
      notificationMediumOptions = _ref.notificationMediumOptions,
      _ref$selectedMedium = _ref.selectedMedium,
      selectedMedium = _ref$selectedMedium === void 0 ? {} : _ref$selectedMedium,
      validateChannels = _ref.validateChannels,
      isFromAllSecrets = _ref.isFromAllSecrets;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      notificationMedium = _useState2[0],
      setNotificationMedium = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isMultipleSlackSelected = _useState4[0],
      setIsMultipleSlackSelected = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      newValue = _useState6[0],
      setNewValue = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = _slicedToArray(_useState7, 2),
      teamsAppChannels = _useState8[0],
      setTeamsAppChannels = _useState8[1];

  var shouldDisableAddingNewRow = function shouldDisableAddingNewRow() {
    if ((0, _isEmpty.default)(newValue === null || newValue === void 0 ? void 0 : newValue.team) || (0, _isEmpty.default)(newValue === null || newValue === void 0 ? void 0 : newValue.channels)) {
      return true;
    }

    return false;
  };

  var onAddTeams = function onAddTeams(addedValue) {
    if (teamsAppChannels !== null && teamsAppChannels !== void 0 && teamsAppChannels.find(function (value) {
      return value.team === addedValue.team;
    })) {
      return;
    } // Update the list with the new pair


    setTeamsAppChannels(function (prevList) {
      return [].concat(_toConsumableArray(prevList), [addedValue]);
    });
  };

  var rowToBeDeleted = function rowToBeDeleted(indexToDelete) {
    var updatedList = _toConsumableArray(teamsAppChannels);

    if (indexToDelete > -1 && indexToDelete < updatedList.length) {
      updatedList.splice(indexToDelete, 1);
    }

    setTeamsAppChannels(updatedList);
  };

  var handleUpdated = function handleUpdated(index, field, value) {
    var updatedList = _toConsumableArray(teamsAppChannels);

    updatedList[index] = _objectSpread(_objectSpread({}, updatedList[index]), {}, _defineProperty({}, field, field === "channels" && typeof value === "string" ? value.length ? value.split(',').map(function (channel) {
      return channel;
    }) : null : value));
    setTeamsAppChannels(updatedList);
  };

  var columns = [{
    field: 'team',
    headerName: 'Team Name',
    width: '180px',
    renderColumn: function renderColumn(row, value, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell"
      }, /*#__PURE__*/_react.default.createElement(_textfield.default, {
        type: "text",
        value: (row === null || row === void 0 ? void 0 : row.team) || "",
        onChange: function onChange(e) {
          handleUpdated(index, "team", e.target.value);
        }
      }));
    }
  }, {
    headerName: 'Channel List',
    width: '380px',
    renderColumn: function renderColumn(row, value, index) {
      var _row$channels;

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell-autocomplete"
      }, /*#__PURE__*/_react.default.createElement(_textfield.default, {
        type: "text",
        width: "280px",
        value: (row === null || row === void 0 ? void 0 : (_row$channels = row.channels) === null || _row$channels === void 0 ? void 0 : _row$channels.join(',')) || '',
        onChange: function onChange(e) {
          handleUpdated(index, "channels", e.target.value);
        }
      })));
    }
  }, {
    headerName: 'Action',
    renderColumn: function renderColumn(row, value, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell"
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: "Delete",
        position: "top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "action-button",
        onClick: function onClick() {
          return rowToBeDeleted(index);
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _deleteIcon.default
      }))));
    }
  }];
  var columnsForNewRow = [{
    width: '140px',
    // eslint-disable-next-line react/display-name
    renderColumn: function renderColumn() {
      return /*#__PURE__*/_react.default.createElement(_textfield.default, {
        type: "text",
        value: newValue === null || newValue === void 0 ? void 0 : newValue.team,
        onChange: function onChange(e) {
          setNewValue(_objectSpread(_objectSpread({}, newValue), {}, {
            team: e.target.value
          }));
        }
      });
    }
  }, {
    width: '380px',
    // eslint-disable-next-line react/display-name
    renderColumn: function renderColumn() {
      var _newValue$channels;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell-autocomplete"
      }, /*#__PURE__*/_react.default.createElement(_textfield.default, {
        type: "text",
        width: "280px",
        value: (newValue === null || newValue === void 0 ? void 0 : (_newValue$channels = newValue.channels) === null || _newValue$channels === void 0 ? void 0 : _newValue$channels.join(',')) || '' // Convert array to comma-separated string
        ,
        disabled: (0, _isEmpty.default)(newValue === null || newValue === void 0 ? void 0 : newValue.team),
        placeholder: "Enter comma-separated channels",
        onChange: function onChange(e) {
          setNewValue(_objectSpread(_objectSpread({}, newValue), {}, {
            channels: e.target.value.split(",").map(function (channel) {
              return channel.trim();
            }) // Split string into array and trim spaces

          }));
        }
      }), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: shouldDisableAddingNewRow() ? 'Please add new Team and Channel' : 'Add',
        position: "right"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: shouldDisableAddingNewRow() ? _disabledSubmitTableRow.default : _submitTableRow.default,
        height: "25",
        onClick: function onClick() {
          if (shouldDisableAddingNewRow()) {
            return;
          }

          !(0, _isEmpty.default)(newValue) && onAddTeams(newValue);
          setNewValue({});
        }
      })));
    }
  }];
  var isEditing = !(0, _isEmpty.default)(selectedMedium);
  var options = (0, _react.useMemo)(function () {
    return (notificationMediumOptions === null || notificationMediumOptions === void 0 ? void 0 : notificationMediumOptions.filter(function (notificationMedium) {
      return !(selectedNotificationMediums !== null && selectedNotificationMediums !== void 0 && selectedNotificationMediums.some(function (existingNotificationMedium) {
        return (notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.name) === (existingNotificationMedium === null || existingNotificationMedium === void 0 ? void 0 : existingNotificationMedium.name);
      }));
    })) || [];
  }, [selectedNotificationMediums, notificationMediumOptions]);

  var filterOptions = function filterOptions(options, selectedNotificationMediums) {
    var hasMagicLink = selectedNotificationMediums === null || selectedNotificationMediums === void 0 ? void 0 : selectedNotificationMediums.some(function (existingNotificationMedium) {
      return (existingNotificationMedium === null || existingNotificationMedium === void 0 ? void 0 : existingNotificationMedium.type) === 'email_with_magic_link';
    });
    var hasEmail = selectedNotificationMediums === null || selectedNotificationMediums === void 0 ? void 0 : selectedNotificationMediums.some(function (existingNotificationMedium) {
      return (existingNotificationMedium === null || existingNotificationMedium === void 0 ? void 0 : existingNotificationMedium.type) === 'email';
    });
    return (options === null || options === void 0 ? void 0 : options.filter(function (notificationMedium) {
      var isMagicLinkConflict = hasMagicLink && (notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.type) === 'email';
      var isEmailConflict = hasEmail && (notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.type) === 'email_with_magic_link';
      var isSlackApp = (notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.type) === _constants.formConstants.slackbotText;
      var isTeamsApp = (notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.type) === _constants.formConstants.teamsbotText; // Check if path includes '/secret-manager' or '/policy-management'

      var isRestrictedPath = (0, _utils.isSMPath)() || (0, _utils.isPolicyManagementPath)(); // If in '/secret-manager' or '/policy-management', exclude both Slack and Teams apps

      if (isRestrictedPath && (isSlackApp || isTeamsApp)) {
        return false;
      } // Return filtered options excluding conflicting notification types


      return !isMagicLinkConflict && !isEmailConflict;
    })) || [];
  };

  var filteredOptions = filterOptions(options, selectedNotificationMediums);
  var props = {
    options: filteredOptions,
    // Passed the filtered options here
    value: notificationMedium,
    label: 'Notification Medium',
    width: '548px',
    placeholder: filteredOptions.length ? 'Select a notification medium' : 'No notification medium found',
    disabled: filteredOptions.length === 0,
    onChange: function onChange(event, value) {
      setNotificationMedium(value);
      setTeamsAppChannels([]);
    },
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    }
  };
  var buttons = [{
    text: isEditing ? 'Save' : 'Add',
    variant: 'primary',
    onClick: function onClick() {
      if (notificationMedium.type === _constants.formConstants.teamsbotText) {
        setNotificationMedium(function (prev) {
          var processedTeamsAppChannels = teamsAppChannels === null || teamsAppChannels === void 0 ? void 0 : teamsAppChannels.map(function (_ref2) {
            var team = _ref2.team,
                channels = _ref2.channels;
            return {
              team: team.trim(),
              channels: channels === null || channels === void 0 ? void 0 : channels.map(function (channel) {
                return channel.trim();
              })
            };
          }); // Check for invalid entries (empty team or empty channels)

          var hasInvalidEntries = processedTeamsAppChannels.some(function (_ref3) {
            var team = _ref3.team,
                channels = _ref3.channels;
            return !team || !(channels !== null && channels !== void 0 && channels.filter(Boolean).length);
          }); // If there are invalid entries, show a toast and update the state

          if (hasInvalidEntries) {
            dispatch((0, _action.openNotification)('error', 'Both team and channels are required! Please ensure neither field is empty.', 3000));
            return _objectSpread(_objectSpread({}, prev), {}, {
              teamsAppChannels: processedTeamsAppChannels
            });
          }

          var updatedMedium = _objectSpread(_objectSpread({}, prev), {}, {
            teamsAppChannels: processedTeamsAppChannels
          });

          onAdd(updatedMedium);
          return updatedMedium;
        });
      } else {
        var deduplicatedChannels = _toConsumableArray(new Set(notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.channels));

        var updatedNotificationMedium = _objectSpread(_objectSpread({}, notificationMedium), {}, {
          channels: deduplicatedChannels
        });

        onAdd(updatedNotificationMedium);
      }
    },
    size: 'medium',
    disabled: !notificationMedium || isMultipleSlackSelected && !isEditing
  }, {
    text: 'Close',
    variant: 'secondary',
    onClick: onCancel,
    size: 'medium'
  }];
  (0, _react.useEffect)(function () {
    if (isEditing) {
      setNotificationMedium(selectedMedium);

      if (!(0, _isEmpty.default)(selectedMedium === null || selectedMedium === void 0 ? void 0 : selectedMedium.teamsAppChannels)) {
        setTeamsAppChannels(selectedMedium === null || selectedMedium === void 0 ? void 0 : selectedMedium.teamsAppChannels);
      }
    }
  }, [JSON.stringify(selectedMedium)]);
  (0, _react.useEffect)(function () {
    var isSlack = selectedNotificationMediums === null || selectedNotificationMediums === void 0 ? void 0 : selectedNotificationMediums.some(function (item) {
      return item.type === 'slack';
    });

    if (isSlack && (notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.type) === 'slack') {
      setIsMultipleSlackSelected(true);
    } else {
      setIsMultipleSlackSelected(false);
    }
  }, [notificationMedium]);
  return /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: 600,
    title: isEditing ? selectedMedium === null || selectedMedium === void 0 ? void 0 : selectedMedium.name : "Add Notification",
    buttons: buttons,
    onCancel: onCancel
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.container
  }, isMultipleSlackSelected && !isEditing && /*#__PURE__*/_react.default.createElement(_snackbar.default, {
    errorList: ['Only one Slack medium is supported per policy.']
  }), error && /*#__PURE__*/_react.default.createElement(_snackbar.default, {
    errorList: Array.isArray(error) ? error : [error]
  }), !isEditing && /*#__PURE__*/_react.default.createElement("div", {
    style: styles.fieldContainer
  }, /*#__PURE__*/_react.default.createElement(_select.default, props)), notificationMedium && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "field-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.fieldContainer
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "heading7"
  }, "Application")), /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, notificationMedium.type === _constants.formConstants.slackbotText ? 'Slack Application' : notificationMedium.type === _constants.formConstants.teamsbotText ? 'Teams Application' : (0, _startCase.default)(notificationMedium.type))), /*#__PURE__*/_react.default.createElement("div", {
    className: "field-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.fieldContainer
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "heading7"
  }, "Description")), /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, notificationMedium.description)), (notificationMedium.type === 'slack' || notificationMedium.type === _constants.formConstants.slackbotText) && /*#__PURE__*/_react.default.createElement("div", {
    style: styles.channelsContainer
  }, /*#__PURE__*/_react.default.createElement(_textarea.default, {
    type: "text",
    helperText: "Comma separated list of ".concat(notificationMedium.type === _constants.formConstants.slackbotText ? 'channel IDs' : 'channels'),
    label: "Channel List",
    value: (notificationMedium === null || notificationMedium === void 0 ? void 0 : (_notificationMedium$c = notificationMedium.channels) === null || _notificationMedium$c === void 0 ? void 0 : _notificationMedium$c.join(',')) || '',
    width: "548px",
    onChange: function onChange(e) {
      e.persist();
      setNotificationMedium(_objectSpread(_objectSpread({}, notificationMedium), {}, {
        channels: e.target.value.length ? e.target.value.split(',').map(function (channel) {
          return channel.trim();
        }) : null
      }));
    },
    disabled: isMultipleSlackSelected && !isEditing
  }), /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "secondary",
    onClick: function onClick() {
      validateChannels(notificationMedium);
    }
  }, "Validate Channels")), (notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.type) === (_constants.formConstants === null || _constants.formConstants === void 0 ? void 0 : _constants.formConstants.slackbotText) && /*#__PURE__*/_react.default.createElement(_ChannelNamesIdsList.default, {
    notificationMedium: notificationMedium,
    isFromAllSecrets: isFromAllSecrets,
    setNotificationMedium: setNotificationMedium,
    disabled: isMultipleSlackSelected && !isEditing
  }), notificationMedium.type === _constants.formConstants.teamsbotText && /*#__PURE__*/_react.default.createElement("div", {
    style: styles.channelsContainer
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_table.default, {
    resizableColumns: true,
    columns: columns || [],
    rows: teamsAppChannels || [],
    addNewRow: true,
    columnsForNewRow: columnsForNewRow
  }))))));
};

NotificationMediumSelector.propTypes = {
  onAdd: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  error: _propTypes.default.string,
  notificationMediumOptions: _propTypes.default.array,
  selectedNotificationMediums: _propTypes.default.array,
  validateChannels: _propTypes.default.func,
  isFromAllSecrets: _propTypes.default.bool,
  selectedMedium: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string,
    type: _propTypes.default.string,
    description: _propTypes.default.string,
    channels: _propTypes.default.array
  })
};
var _default = NotificationMediumSelector;
exports.default = _default;